import { allowsStatistics } from "@/lib/cookieConsent";

const KEY = "autopark_visit_sid";
let ephemeralSid = null;

export function getVisitSessionId() {
  if (!allowsStatistics()) {
    if (!ephemeralSid) {
      ephemeralSid =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? `v-${crypto.randomUUID()}`
          : `v-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    }
    return ephemeralSid;
  }
  try {
    let sid = localStorage.getItem(KEY);
    if (!sid) {
      sid = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return `v-anon-${Date.now()}`;
  }
}
